const EndOfImageMarker = {
  name: () => "EOI",
};

export default EndOfImageMarker;
